module.exports = __webpack_public_path__ + "img/img2.af00b49e.png";